import React from 'react'
import { Modal, Result, Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { MAPPING_WIZARD_ROUTE } from '../../groupCustomerMapping/mappingRoutes'

interface ReconciliationEmptyMappingStateProps {
  open: boolean
}

/**
 * Blocking modal shown when the group has no complete customer/supplier links between any
 * companies yet - reconciliation is not meaningful without at least one. Not persisted: reappears
 * on every visit until at least one pair is fully linked (unlike the dismissible partial-mapping
 * alert).
 */
const ReconciliationEmptyMappingState: React.FC<ReconciliationEmptyMappingStateProps> = ({ open }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [closed, setClosed] = React.useState(false)

  return (
    <Modal open={open && !closed} footer={null} closable onCancel={() => setClosed(true)} centered>
      <Result
        status="warning"
        title={t(
          'icReconciliation:mappingEmptyTitle',
          'Yritysten välillä ei ole yhtään asiakas- tai toimittajalinkitystä'
        )}
        subTitle={t(
          'icReconciliation:mappingEmptySubtitle',
          'Täsmäytys ei voi tuottaa tuloksia ilman linkityksiä. Aloita konsernin yritysten linkitys ohjatulla toiminnolla.'
        )}
        extra={
          <Button type="primary" onClick={() => navigate(MAPPING_WIZARD_ROUTE)}>
            {t('icReconciliation:mappingEmptyAction', 'Aloita linkitys')}
          </Button>
        }
      />
    </Modal>
  )
}

export default ReconciliationEmptyMappingState
